import React, { useEffect } from 'react';
import BrandLogo from './BrandLogo';

const Sidebar = ({ loggedIn, logout, handleUploadShow, currentPage, onPageChange, isOpen, onClose }) => {
    // Handle ESC key press
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscKey);
            document.body.style.overflow = 'hidden'; // Prevent background scroll
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.removeEventListener('keydown', handleEscKey);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    // Handle backdrop click
    const handleBackdropClick = (e) => {
        if (e.target.classList.contains('sidebar-overlay')) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="sidebar-overlay" onClick={handleBackdropClick}>
            <div className="modern-sidebar hamburger-sidebar" role="dialog" aria-modal="true" aria-label="Navigation">
                <div className="sidebar-header">
                    <div className="sidebar-logo">
                        <BrandLogo className="sidebar-brand-logo" />
                    </div>
                    <button className="sidebar-close-btn" onClick={onClose} aria-label="Close menu">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                </div>
                
                <div className="sidebar-nav">
                    <button 
                        className={`sidebar-nav-item ${currentPage === 'home' ? 'active' : ''}`}
                        onClick={() => { onPageChange('home'); onClose(); }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M4 10.5L12 4l8 6.5V20h-6v-6h-4v6H4v-9.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                        </svg>
                        <span>Home</span>
                    </button>
                    
                    <button 
                        className={`sidebar-nav-item ${currentPage === 'videos' ? 'active' : ''}`}
                        onClick={() => { onPageChange('videos'); onClose(); }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M15.5 15.5L20 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <span>Search & play</span>
                    </button>
                    
                    {loggedIn && (
                        <button className="sidebar-nav-item" onClick={() => { handleUploadShow(); onClose(); }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M5 14v5h14v-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span>Upload</span>
                        </button>
                    )}
                    
                    {loggedIn && (
                        <button className="sidebar-nav-item" onClick={() => { logout(); onClose(); }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M10 5H5v14h5M14 8l4 4-4 4m4-4H9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span>Logout</span>
                        </button>
                    )}
                </div>
                <div className="sidebar-footer">Search is the fastest way to start watching.</div>
            </div>
        </div>
    );
};

export default Sidebar;